import { useState, useEffect } from 'react';
import { inventory } from '../utils/data';
import { tableHeader, tableData, title } from '../utils/style';
import Table from '../reusable_components/Table';

function SoftwareUpdate() {
    const [ softwareUpdate , setSoftwareUpdate ] = useState([]);

    useEffect(() => {
        const data = [];
        for(let i = 0; i < 10; i++){
            data.push(inventory.softwareUpdates[0])
        }
        console.log(data)
        setSoftwareUpdate(data)
    }, [])

    const options = [
        {
            header: 'Manufacturer',
            key: 'manufacturer',
        },
        {
            header: 'Patch Release On',
            key: 'patchReleaseOn',
            placeHolder: 'mm-dd-yyyy'
        },
        {
            header: 'Patch Type',
            key: 'patchType',
        },
        {
            header: 'Count of Applications',
            key: 'countOfApplications',
        }
    ]

    return(
        <div className="p-4">
            <div className={`${title} mb-4`}>Software Updates</div>
            
            <Table
                options={options}
                tableData={softwareUpdate}
                noButton
            />
        </div>
    )
}

export default SoftwareUpdate;